import { Box, Typography, makeStyles } from '@material-ui/core';
import { ITheme } from '../constants/theme';
import { textButtonHoverAndActive } from '../utils/styles/buttonStyles';
import { useHistory } from 'react-router-dom';
import { ProOrganisation } from '../redux/actions/subscriptions';
import { formatDate } from '../utils/dateTimeFormatting';
import { t } from 'i18next';

const useStyles = makeStyles((theme: ITheme) => ({
  card: {
    cursor: 'pointer',
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "24px 16px 24px 24px",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
    transition: "all 200ms ease",
    marginBottom: 16,
    ...textButtonHoverAndActive
  },
  topTextContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  nameAndStatusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap'
  },
  detailsLine: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap'
  },
  diamondSeparator: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    fontWeight: 600
  },
  collectEnabled: {
    color: theme.palette.success.main,
    fontWeight: 700,
  },
  collectDisabled: {
    color: theme.palette.warning.main,
    fontWeight: 700,
  },
  membersCount: {
    margin: "8px 0",
    fontWeight: 500,
    color: theme.palette.text.secondary
  },
  createdDate: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary
  }
}));

interface IProOrganisationCardProps extends ProOrganisation {
  refreshList: () => void;
}

export default function ProOrganisationCard(props: IProOrganisationCardProps) {
  const {
    Id,
    Name,
    PhoneNumber,
    VATNumber,
    Created,
    IsCollectEnabled,
    MembersCount
  } = props;
  const history = useHistory<{ from: string; }>();
  const classes = useStyles();

  function onClick() {
    let url = `/admin/pro/${Id}`;
    history.push(url);
  }

  return (
    <Box
      className={classes.card}
      onClick={onClick}>
      <Box className={classes.topTextContainer}>
        <Box className={classes.nameAndStatusContainer}>
          <Typography variant="h6" component="h2">
            {Name}
          </Typography>
          <Typography variant="body2" className={classes.membersCount}>
            {MembersCount} member{MembersCount !== 1 ? 's' : ''}
          </Typography>
          <Typography
            variant="body2"
            className={IsCollectEnabled ? classes.collectEnabled : classes.collectDisabled}
            component="span">
            {IsCollectEnabled ? 'TKD Enabled' : 'TKD Disabled'}
          </Typography>
        </Box>
        
        <Box className={classes.detailsLine}>
          {PhoneNumber && (
            <>
              <Typography variant="body2" color="textSecondary">
                <span style={{ fontWeight: 700 }}>{t('orderDetails.phone')}:</span> {PhoneNumber}
              </Typography>
              <span className={classes.diamondSeparator}>◆</span>
            </>
          )}
          {VATNumber && (
            <>
              <Typography variant="body2" color="textSecondary">
                <span style={{ fontWeight: 700 }}>{t('common.vat')}:</span> {VATNumber}
              </Typography>
              <span className={classes.diamondSeparator}>◆</span>
            </>
          )}
          <Typography variant="body2" className={classes.createdDate}>
            <span style={{ fontWeight: 700 }}>{t('common.created')}:</span> {formatDate(Created)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
